<template>
  <section class="wrap gray">
    <div class="container-wrap observer-selector">
      <div class="title">많은 사람들이 디버를 선택하는 이유</div>
      <div class="box-wrap">
        <div v-for="list in infoList">
          <Box :list="list" ref="boxes" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Box from "./box.vue";

export default {
  components: { Box },
  data() {
    return {
      infoList: [
        {
          img: require("@/assets/img/home/img_reason_1.png"),
          content: "실시간 배송<br/>현황 조회"
        },
        {
          img: require("@/assets/img/home/img_reason_2.png"),
          content: "원하는 픽업일시<br/>지정 주문"
        },
        {
          img: require("@/assets/img/home/img_reason_3.png"),
          content: "오토바이와 동일한<br/> 승용차 배송 금액"
        },
        {
          img: require("@/assets/img/home/img_reason_4.png"),
          content: "더 빠르게 배송하는<br/> 급송 서비스"
        },
        {
          img: require("@/assets/img/home/img_reason_5.png"),
          content: "안심할 수 있는<br/>픽업/도착사진 제공"
        },
        {
          img: require("@/assets/img/home/img_reason_6.png"),
          content: "체계적인<br/> 전담 CS팀 운영"
        }
      ]
    };
  }
};
</script>
<style src="../home.common.css" scoped />
<style scoped>
.gray-wrap {
  background-color: var(--gray-200);
  padding: 80px 20px;
}

.box-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 40px;
}

.title {
  color: var(--gray-700);
  font-size: 32px;
  font-weight: 500;
  line-height: 44px;
}

@media (min-width: 1024px) {
  .gray-wrap {
    padding: 112px 0;
    display: flex;
    justify-content: center;
  }

  .box-wrap {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    margin-top: 56px;
  }

  .title {
    font-size: 40px;
    line-height: 52px;
  }
}
</style>
